import { useSuspenseQuery } from '@apollo/client/react';
import { ErrorAlert } from '@optools/components/alerts/error';
import { Separator } from '@optools/components/ui/separator';
import { PIPELINE_MONITORS } from '@optools/services/operator-gateway/qa-tools/queries';
import { BorrowPipelineDialog } from '@optools/tools/qa-tools/components/borrow-pipeline-dialog';
import { DevPipelineMonitorCard } from '@optools/tools/qa-tools/components/dev-pipeline-monitor-card';
import { ProdPipelineMonitorCard } from '@optools/tools/qa-tools/components/prod-pipeline-monitor-card';
import {
  filterAndSortBorrowedProdPipelineMonitors,
  filterAndSortDevPipelineMonitors,
} from '@optools/tools/qa-tools/utils/pipeline-monitors';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/qa-tools/dev-configs')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { data, error, refetch } = useSuspenseQuery(PIPELINE_MONITORS, {
    context: { skipErrorNotification: true },
  });

  if (error) {
    return <ErrorAlert error={error} title="Pipeline Monitors Error" onRetry={refetch} />;
  }

  const devMonitors = filterAndSortDevPipelineMonitors(data.pipelineMonitors ?? []);
  const borrowedMonitors = filterAndSortBorrowedProdPipelineMonitors(data.pipelineMonitors ?? []);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex grow flex-col">
        <h1 className="mb-4">Dev Pipeline Config Management</h1>
        <ul className="grid auto-rows-fr grid-cols-[repeat(auto-fill,minmax(360px,1fr))] gap-4 overflow-auto">
          {devMonitors.map((monitor) => {
            return (
              <li key={monitor.pipelineConfig?.id}>
                <DevPipelineMonitorCard monitor={monitor} />
              </li>
            );
          })}
        </ul>
      </div>
      <div className="flex flex-col">
        <Separator />
        <div className="mt-4 mb-4 flex items-center gap-4">
          <h1>Borrowed Pipelines</h1>
          <BorrowPipelineDialog />
        </div>
        <ul className="grid auto-rows-fr grid-cols-[repeat(auto-fill,minmax(360px,1fr))] gap-4">
          {borrowedMonitors.map((monitor) => {
            return (
              <li key={monitor.pipelineConfig?.id}>
                <ProdPipelineMonitorCard monitor={monitor} />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
